import { ClipboardCheck, Coins, Database, Flag, Rocket } from "lucide-react";
import type { ReactNode } from "react";
import { useT } from "../i18n/I18nProvider";
import type { MessageKey } from "../i18n/keys";

/** A menu label in the reader's language (the menu renders the label as it is). */
function Label({ k }: { k: MessageKey }) {
  return <>{useT()(k)}</>;
}

/** The admin menu's Library entries (one per group of app/design/library/content/library.yaml). */
export const LIBRARY_MENU: [string, ReactNode, ReactNode][] = [
  ["/admin/library/stack", <Label key="l" k="library.menu.stack" />, <Coins key="i" />],
  ["/admin/library/releases", <Label key="l" k="library.menu.releases" />, <Rocket key="i" />],
  ["/admin/library/strategies", <Label key="l" k="library.menu.strategies" />, <Flag key="i" />],
  ["/admin/library/data-sources", <Label key="l" k="library.menu.dataSources" />, <Database key="i" />],
  ["/admin/library/quality", <Label key="l" k="library.menu.quality" />, <ClipboardCheck key="i" />],
];
